import { useState } from 'react';
import { format } from 'date-fns';
import { ScheduleItem, Appointment, Task } from '../components/SchedulerTypes';

export const useDailyViewState = () => {
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const [isAppointmentModalOpen, setIsAppointmentModalOpen] = useState(false);
  const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<string>('');
  const [selectedPerson, setSelectedPerson] = useState<string>('');
  const [selectedIsDoctor, setSelectedIsDoctor] = useState<boolean>(false);
  const [editingItem, setEditingItem] = useState<ScheduleItem | null>(null);
  const [selectedScheduleForAppointment, setSelectedScheduleForAppointment] = useState<ScheduleItem | null>(null);
  const [selectedScheduleForTask, setSelectedScheduleForTask] = useState<ScheduleItem | null>(null);
  const [editingAppointment, setEditingAppointment] = useState<Appointment | null>(null);
  const [editingTask, setEditingTask] = useState<Task | null>(null);

  const openScheduleModal = (timeSlot?: string, personId?: string, isDoctor?: boolean, item?: ScheduleItem) => {
    if (item) {
      setEditingItem(item);
    } else {
      setSelectedTimeSlot(timeSlot || '');
      setSelectedPerson(personId || '');
      setSelectedIsDoctor(isDoctor || false);
      setEditingItem(null);
    }
    setIsScheduleModalOpen(true);
  };

  const closeScheduleModal = () => {
    setIsScheduleModalOpen(false);
    setEditingItem(null);
  };

  const openAppointmentModal = (schedule: ScheduleItem, appointment?: Appointment) => {
    setSelectedScheduleForAppointment(schedule);
    setEditingAppointment(appointment || null);
    setIsAppointmentModalOpen(true);
  };

  const closeAppointmentModal = () => {
    setIsAppointmentModalOpen(false);
    setSelectedScheduleForAppointment(null);
    setEditingAppointment(null);
  };

  const openTaskModal = (schedule: ScheduleItem, task?: Task) => {
    setSelectedScheduleForTask(schedule);
    setEditingTask(task || null);
    setIsTaskModalOpen(true);
  };

  const closeTaskModal = () => {
    setIsTaskModalOpen(false);
    setSelectedScheduleForTask(null);
    setEditingTask(null);
  };

  return {
    // Schedule Modal
    isScheduleModalOpen,
    selectedTimeSlot,
    selectedPerson,
    selectedIsDoctor,
    editingItem,
    openScheduleModal,
    closeScheduleModal,
    
    // Appointment Modal
    isAppointmentModalOpen,
    selectedScheduleForAppointment,
    editingAppointment,
    openAppointmentModal,
    closeAppointmentModal,
    
    // Task Modal
    isTaskModalOpen,
    selectedScheduleForTask,
    editingTask,
    openTaskModal,
    closeTaskModal,
  };
};
